import React, { useState, useEffect } from 'react';

const DEFAULT_RULE = { name: '', target: '', max_upload: '1M', max_download: '5M', priority: '8', comment: '' };

export default function StepQoS({ data, onChange, onNext, onBack }) {
  const [rules, setRules] = useState(data && data.rules && data.rules.length > 0 ? data.rules : [{ ...DEFAULT_RULE }]);

  useEffect(() => {
    if (data && data.rules) setRules(data.rules);
  }, [data]);

  const save = (updated) => {
    setRules(updated);
    onChange({ rules: updated });
  };

  const update = (index, key, value) => {
    const updated = [...rules];
    updated[index] = { ...updated[index], [key]: value };
    save(updated);
  };

  const add = () => save([...rules, { ...DEFAULT_RULE }]);

  const remove = (index) => {
    if (rules.length <= 1) return;
    save(rules.filter((_, i) => i !== index));
  };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">🚦 จำกัดความเร็ว (QoS)</h2>
        <p className="text-gray-500 dark:text-gray-400">ควบคุมแบนด์วิดท์ของผู้ใช้แต่ละคนหรือแต่ละเครือข่าย ป้องกันคนเดียวใช้เน็ตทั้งหมด</p>
      </div>

      <div className="space-y-4">
        {rules.map((rule, index) => (
          <div key={index} className="p-5 bg-gradient-to-br from-gray-50 to-white dark:from-gray-700/50 dark:to-gray-800/50 rounded-xl border border-gray-200 dark:border-gray-600 shadow-sm">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 bg-gradient-to-br from-yellow-500 to-yellow-600 text-white rounded-lg flex items-center justify-center text-sm font-bold shadow-md">{index + 1}</span>
                <span className="font-bold text-gray-900 dark:text-white">{rule.name || 'คิวที่ ' + (index + 1)}</span>
              </div>
              <button onClick={() => remove(index)} className="btn-danger" disabled={rules.length <= 1}>ลบ</button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="label">ชื่อกฎ</label>
                <input type="text" value={rule.name} onChange={e => update(index, 'name', e.target.value)} className="input-field" placeholder="guest-limit" />
              </div>
              <div>
                <label className="label">เป้าหมาย (IP/CIDR/MAC)</label>
                <input type="text" value={rule.target} onChange={e => update(index, 'target', e.target.value)} className="input-field" placeholder="192.168.88.100 หรือ 192.168.20.0/24" />
              </div>
              <div>
                <label className="label">⬆️ จำกัดอัปโหลด</label>
                <input type="text" value={rule.max_upload} onChange={e => update(index, 'max_upload', e.target.value)} className="input-field" placeholder="1M" />
                <p className="text-[10px] text-gray-400 mt-1">เช่น 1M, 5M, 10M, 100M</p>
              </div>
              <div>
                <label className="label">⬇️ จำกัดดาวน์โหลด</label>
                <input type="text" value={rule.max_download} onChange={e => update(index, 'max_download', e.target.value)} className="input-field" placeholder="5M" />
              </div>
              <div>
                <label className="label">ลำดับความสำคัญ (1-8)</label>
                <select value={rule.priority} onChange={e => update(index, 'priority', e.target.value)} className="input-field">
                  {[1,2,3,4,5,6,7,8].map(n => <option key={n} value={n}>{n} {n <= 2 ? '(สูงสุด)' : n <= 4 ? '(สูง)' : n <= 6 ? '(ปานกลาง)' : '(ต่ำ)'}</option>)}
                </select>
              </div>
              <div>
                <label className="label">💬 หมายเหตุ</label>
                <input type="text" value={rule.comment} onChange={e => update(index, 'comment', e.target.value)} className="input-field" placeholder="เช่น จำกัดความเร็วเครือข่ายแขก" />
              </div>
            </div>
          </div>
        ))}
      </div>

      <button onClick={add} className="mt-4 px-4 py-3 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl text-gray-500 dark:text-gray-400 hover:border-yellow-500 hover:text-yellow-500 transition-colors w-full font-medium text-sm">
        + เพิ่มกฎจำกัดความเร็ว
      </button>

      <div className="mt-4 p-3 bg-yellow-50 dark:bg-yellow-900/10 border border-yellow-100 dark:border-yellow-800/50 rounded-lg">
        <p className="text-xs text-yellow-700 dark:text-yellow-300">
          <strong>💡 เคล็ดลับ:</strong> ใช้ CIDR (เช่น 192.168.20.0/24) เพื่อจำกัดความเร็วทั้งเครือข่าย หรือใช้ IP เดี่ยว (เช่น 192.168.88.100) สำหรับผู้ใช้คนเดียว
        </p>
      </div>

      <div className="flex justify-between mt-6">
        <button onClick={onBack} className="btn-secondary">← ย้อนกลับ</button>
        <button onClick={onNext} className="btn-primary">ถัดไป ({rules.length} กฎ)</button>
      </div>
    </div>
  );
}
